import { render, staticRenderFns } from "./TheNavbarVerticalPerfil.vue?vue&type=template&id=e4788a9c&scoped=true&"
import script from "./TheNavbarVerticalPerfil.vue?vue&type=script&lang=js&"
export * from "./TheNavbarVerticalPerfil.vue?vue&type=script&lang=js&"
import style1 from "./TheNavbarVerticalPerfil.vue?vue&type=style&index=1&id=e4788a9c&prod&scoped=true&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4788a9c",
  null
  
)

export default component.exports